import { createStyles, makeStyles, MenuItem, Theme, Typography } from "@material-ui/core";
import { ChangeEvent, useState } from "react";
import { IProfileSelectionFormValues } from "../_interfaces/IProfileSelectionFormValues";
import REMSelect from "../../../shared/modules/rem-conversion/components/Select";
import { UserProfileTypes } from "../../../data/UserProfileTypes";
import { IOrganization } from "../../../stores";
import { observer } from "mobx-react";
import FormLoadingSpinner from "../../../components/Organization/VolunteerOpportunities/FormLoadingSpinner";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            position: 'relative'
        },
        field: {
            marginTop: theme.spacing(2)
        },
        bold: {
            fontWeight: 'bold'
        },
        select: {
            maxWidth: '300px',
            display: 'flex'
        },
        icon: {
            padding: theme.spacing(1),
            color: 'rgba(0, 0, 0, 0.54)'
        },
    }),
);

interface ProfileSelectionFormProps {
    values: IProfileSelectionFormValues;
    onChange: (patch: Partial<IProfileSelectionFormValues>) => void;
    onSubmit: (override?: Partial<IProfileSelectionFormValues>) => void;
    isSubmitting?: boolean;
    error?: string;
    fieldErrors?: Partial<Record<keyof IProfileSelectionFormValues, string>>;
}

export const ProfileSelectionForm: React.FC<ProfileSelectionFormProps> = observer(({
    values,
    onChange,
    onSubmit,
    isSubmitting,
    error,
    fieldErrors
}) => {

    /********** State **********/

    const getFormId = () => {
        return `form-profile-selection-${Date.now()}-${Math.random()}`;
    }

    const [formId] = useState(() => getFormId());

    /********** React hooks **********/

    const classes = useStyles();

    /********** Event handlers **********/

    const onDefaultProfileChanged = (event: ChangeEvent<{
        name?: string;
        value: unknown;
    }>, child: React.ReactNode
    ) => {
        event.preventDefault(); // Prevent page reload
        event.stopPropagation();
        if (typeof event.target.value === 'number') {
            onChange({ defaultProfileId: event.target.value });
        }
    }

    const onActiveProfileChanged = (event: ChangeEvent<{
        name?: string;
        value: unknown;
    }>, child: React.ReactNode
    ) => {
        event.preventDefault(); // Prevent page reload
        event.stopPropagation();
        if (typeof event.target.value === 'number') {
            onChange({ activeProfileId: event.target.value });
        }
    }

    /********** Helper methods **********/

    // const defaultSelectOption = (
    //     <MenuItem value={-1}>
    //         Select a profile
    //     </MenuItem>
    // )

    const profileOptions = values.profiles?.map((profile, index) => {
        return (
            <MenuItem key={`profile-${index}`} value={profile.id}>
                {
                    profile.type === UserProfileTypes.Nonprofit
                        ? `${(profile.identity as IOrganization).name} Admin`
                        : profile.type
                }
            </MenuItem>
        );
    })

    /********** Render **********/

    return (
        <form
            noValidate
            autoComplete="off"
            id={formId}
            className={classes.form}
        >
            {values.loading ? <FormLoadingSpinner /> : undefined}
            <div className={classes.field}>
                <Typography className={classes.bold}>
                    {"Default profile: "}
                </Typography>
                <REMSelect
                    id="default-profile-dropdown"
                    defaultValue={values.defaultProfileId}
                    value={values.defaultProfileId}
                    onChange={onDefaultProfileChanged}
                    className={classes.select}
                    variant="outlined"
                // startAdornment={
                //     <InputAdornment position="start" className={classes.icon}>
                //         <CardAccountDetails />
                //     </InputAdornment>
                // }
                >
                    {/* {defaultSelectOption} */}
                    {profileOptions}
                </REMSelect>
            </div>
            <div className={classes.field}>
                <Typography className={classes.bold}>
                    {"Active profile: "}
                </Typography>
                <REMSelect
                    id="active-profile-dropdown"
                    defaultValue={values.activeProfileId}
                    value={values.activeProfileId}
                    onChange={onActiveProfileChanged}
                    className={classes.select}
                    variant="outlined"
                // startAdornment={
                //     <InputAdornment position="start" className={classes.icon}>
                //         <CardAccountDetails />
                //     </InputAdornment>
                // }
                >
                    {/* {defaultSelectOption} */}
                    {profileOptions}
                </REMSelect>
            </div>
        </form >
    );
});